import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Award, GraduationCap } from 'lucide-react';

export const Partners = () => {
  const partners = [
    {
      name: 'Jay Kothari',
      role: 'Principal & Founder',
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_kothari-services/artifacts/zpwu693e_WhatsApp%20Image%202026-09-24%20at%2018.35.58.jpeg',
      qualifications: ['Bachelor of Commerce (B.Com)', 'Bachelor of Law (LLB) from DAVV'],
      description: 'Founder and principal of Jay Kothari and Company. A distinguished tax consultant with over 38 years of experience serving clients in Indore since 1986.',
      expertise: ['Income Tax', 'Corporate Law', 'Tax Consultancy']
    },
    {
      name: 'Jainesh Kothari',
      role: 'Senior Partner',
      image: 'https://customer-assets.emergentagent.com/job_kothari-services/artifacts/vml6c0t5_Jainesh%20Kothari%20image%20for%20website.jpg',
      qualifications: [
        'Tax Consultant',
        'Certified Financial Planner® (CFP®)',
        'Qualified Personal Finance Professional® (QPFP®)',
        'Chartered Trust and Estate Planner® (CTEP®)'
      ],
      description: 'The backbone of Jay Kothari and Company, managing everything from tax filing to personal finance. A passionate content creator who has built the firm\'s digital presence over the last 8 years.',
      expertise: ['Tax Filing', 'Personal Finance', 'Estate Planning', 'Digital Strategy']
    },
    {
      name: 'Abhijeet Kothari',
      role: 'Partner',
      image: 'https://customer-assets.emergentagent.com/job_kothari-services/artifacts/qx88p7je_Abhijjett%20kothari%20image%20for%20website.jpg',
      qualifications: [
        'Bachelor of Commerce (B.Com)',
        'NISM VA Certified',
        'Multiple Financial Certifications'
      ],
      description: 'Manages investment and financial portfolios of clients. Handles ITR filing during tax season with expertise in investment advisory.',
      expertise: ['Investment Management', 'Financial Portfolios', 'ITR Filing', 'NISM Certified Services']
    }
  ];

  return (
    <div className="bg-background py-24 md:py-32" data-testid="partners-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-wide uppercase text-secondary mb-4">Our Team</p>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight leading-tight font-playfair mb-6" data-testid="partners-title">
            Meet Our Partners
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-muted-foreground max-w-3xl mx-auto">
            Three generations of expertise working together to serve your financial needs.
          </p>
        </div>

        <div className="space-y-12">
          {partners.map((partner, index) => (
            <Card key={index} className="overflow-hidden hover:shadow-xl transition-all duration-300" data-testid={`partner-${index}`}>
              <CardContent className="p-8 lg:p-12">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  <div className="lg:col-span-1">
                    <div className="rounded-xl overflow-hidden shadow-lg bg-white">
                      <img 
                        src={partner.image} 
                        alt={partner.name}
                        className="w-full object-contain"
                        style={{ aspectRatio: '4/5' }}
                      />
                    </div>
                  </div>
                  <div className="lg:col-span-2">
                    <h2 className="text-3xl font-bold font-playfair mb-2">{partner.name}</h2>
                    <p className="text-lg text-secondary font-semibold mb-4">{partner.role}</p>
                    <p className="text-muted-foreground mb-6">{partner.description}</p>
                    
                    <div className="mb-6">
                      <h3 className="flex items-center gap-2 font-semibold mb-3">
                        <GraduationCap className="h-5 w-5 text-secondary" />
                        Qualifications
                      </h3>
                      <ul className="space-y-2">
                        {partner.qualifications.map((qual, idx) => (
                          <li key={idx} className="text-sm text-muted-foreground flex items-center">
                            <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
                            {qual}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div>
                      <h3 className="font-semibold mb-3">Areas of Expertise</h3>
                      <div className="flex flex-wrap gap-2">
                        {partner.expertise.map((exp, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1 bg-muted text-sm rounded-full"
                          >
                            {exp}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
